export const SHOP_URL = "https://www.hourlierwines.co.uk";

export const shopLinks = {
  home: SHOP_URL,
  wineClub: `${SHOP_URL}/pages/wine-club`,
  contact: `${SHOP_URL}/pages/contact`,
  ourShop: `${SHOP_URL}/pages/our-shop`,
  news: `${SHOP_URL}/blogs/news`,
  delivery: `${SHOP_URL}/pages/delivery`,
  product: (handle: string) => `${SHOP_URL}/products/${handle}`,
};

export const safeNext = (raw: string | null): string | null => (raw && raw.startsWith("/") && !raw.startsWith("//") ? raw : null);
